module.exports = __webpack_public_path__ + "static/media/img15.5e13f937.jpg";